import { convertDateTime } from "Helpers/date";

export function formatUsPhone(phoneNumberString) {
  if (phoneNumberString === "") {
    return "";
  }
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return phoneNumberString;
}
// convert normal url to imgix
export function convertimgixurl(
  imgUrl,
  findDomain,
  replaceDomain,
  width = "",
  height = "",
  dpr = "",
  xlib = ""
) {
  if (
    imgUrl == "null" ||
    imgUrl == null ||
    imgUrl == "" ||
    imgUrl == undefined ||
    imgUrl == "undefined"
  )
    return;

  if (!(imgUrl && replaceDomain)) return;

  // check find domain exits or not in imgurl
  if (imgUrl.indexOf(replaceDomain) !== -1) {
    // append query parameter
    let final_url = imgUrl;
    if (width) final_url = appendurl(final_url, "w", width);

    if (height) final_url = appendurl(final_url, "h", height);

    if (dpr) final_url = appendurl(final_url, "dpr", dpr);

    if (xlib) final_url = appendurl(final_url, "xlib", xlib);

    return final_url;
  } else {
    return imgUrl;
  }
}

// append query paramenter in url
export function appendurl(imgUrl, appendKey, appendValue) {
  if (!(imgUrl && appendKey && appendValue)) return;

  var url = new URL(imgUrl);
  var search_params = url.searchParams;

  search_params.set(appendKey, appendValue);

  url.search = search_params.toString();

  // the new url string
  var new_url = url.toString();

  return new_url;
}

// Check for the valid Email ID
export function checkValidEmailId(emilId) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emilId)) {
    return true;
  } else {
    return false;
  }
}

//convert time
export function convertUtcToPstTime(time) {
  let convertTime = convertDateTime(time, "seconds3", "hh:mm a");
  return convertTime;
}

export function convertUtcTimestampToPstDate(time, format) {
  let convertTime = convertDateTime(time, "seconds3", format);
  return convertTime;
}

